<ng-container *ngIf="data; else loadingTmpl">
  <qrcode [qrdata]="data" [width]="size" errorCorrectionLevel="M" @fade></qrcode>
</ng-container>

<ng-template #loadingTmpl>
  <vnm-empty-message [loading]="true" loadingMessage="qr-code.loading-message"></vnm-empty-message>
</ng-template>
